<div class="row page-header">
    <div class="col-12">
        <h1>Bid Rate <small>Actual labor, equipment, and overhead rates from Vista</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Labor</a>
            <ng-template ngbNavContent>
                <div class="row action-toolbar" style="margin-top: 20px">
                    <div class="col-12">
                        <form class="form-inline">
                            <div class="input-header-group">
                                <span class="input-header">Start Month</span>
                                <wj-input-date
                                    [(ngModel)]="startDate"
                                    class="header-input"
                                    name="startDate"
                                    (ngModelChange)="onRangeChanged()"
                                    [selectionMode]="'Month'"
                                    [format]="'MMM yyyy'"
                                    [min]="minDate"
                                    [max]="maxDate"
                                ></wj-input-date>
                            </div>

                            <div class="input-header-group">
                                <span class="input-header">End Month</span>
                                <wj-input-date
                                    [(ngModel)]="endDate"
                                    class="header-input"
                                    name="endDate"
                                    (ngModelChange)="onRangeChanged()"
                                    [selectionMode]="'Month'"
                                    [format]="'MMM yyyy'"
                                    [min]="minDate"
                                    [max]="maxDate"
                                ></wj-input-date>
                            </div>

                        </form>
                    </div>
                </div>

                @if (rangeInvalid) {
                    <p class="text-danger mt-2">Start month must be on or before the end month.</p>
                }

                <h5 class="mt-3 mb-1">Class Rate Summary</h5>
                <p class="text-muted mb-2">
                    Average for the selected months, weighted by hours. Fringe Combined is health, PTO, life/disability/EAP, and 401k. This view has no month-by-month history.
                </p>
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <action-toolbar-count [grid]="summaryGrid"></action-toolbar-count>
                            <action-toolbar-search name="summarySearch" [(ngModel)]="summaryGrid.filter"></action-toolbar-search>
                            <grid-export [grid]="summaryRateGrid" [name]="'Labor Rate Summary'"></grid-export>
                        </form>
                    </div>
                </div>
                <wj-flex-grid
                    #summaryRateGrid
                    style="height: 360px"
                    [isReadOnly]="true"
                    (initialized)="summaryGrid.initialize(summaryRateGrid)"
                    (destroy)="summaryGrid.destroy()"
                    [itemsSource]="summaryGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Class'" [binding]="'classDisplay'" [width]="280"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Hours'" [binding]="'hours'" [width]="100" [format]="'n1'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Wage'" [binding]="'wageRate'" [width]="110" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Payroll Taxes'" [binding]="'payrollTaxRate'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Workers Comp'" [binding]="'workersCompRate'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Fringe Combined'" [binding]="'fringeCombinedRate'" [width]="150" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Total Burden'" [binding]="'totalBurdenRate'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Fully Loaded'" [binding]="'fullyLoadedRate'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="summaryRateGrid"></grid-selection-calculation>

                <h5 class="mt-4 mb-1">Rate History by Class</h5>
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <action-toolbar-count [grid]="grid"></action-toolbar-count>
                            <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                            <grid-export [grid]="mainGrid" [name]="'Labor Rates'"></grid-export>

                            <div class="input-header-group" [hidden]="compareClasses">
                                <span class="input-header">Class</span>
                                <wj-combo-box
                                    [(ngModel)]="selectedClass"
                                    name="selectedClass"
                                    (ngModelChange)="rebuildChart()"
                                    [itemsSource]="classOptions"
                                    [displayMemberPath]="'display'"
                                    [selectedValuePath]="'value'"
                                ></wj-combo-box>
                            </div>

                            <div class="input-header-group">
                                <span
                                    class="input-header"
                                    title="Plot the fully loaded rate for several classes at once. The chart shows the first five selected classes. The grid lists every selected class."
                                    >Compare Classes</span
                                >
                                <wj-combo-box
                                    [(ngModel)]="compareClasses"
                                    name="compareClasses"
                                    (ngModelChange)="onCompareChanged()"
                                    [itemsSource]="yesNoOptions"
                                    [displayMemberPath]="'display'"
                                    [selectedValuePath]="'value'"
                                    style="width: 115px"
                                ></wj-combo-box>
                            </div>

                            <div class="input-header-group" [hidden]="!compareClasses">
                                <span class="input-header">Classes</span>
                                <wj-multi-select
                                    name="compareClassList"
                                    [itemsSource]="classOptions"
                                    [displayMemberPath]="'display'"
                                    [checkedMemberPath]="'$checked'"
                                    [placeholder]="'Select classes'"
                                    (checkedItemsChanged)="rebuildChart()"
                                ></wj-multi-select>
                            </div>

                            <div class="input-header-group" [hidden]="compareClasses">
                                <span
                                    class="input-header"
                                    title="Split the chart into wage and each burden line (payroll taxes, workers comp, health, PTO, life, and 401k) instead of one total burden line."
                                    >Burden Detail</span
                                >
                                <wj-combo-box
                                    [(ngModel)]="showBurdenDetail"
                                    name="showBurdenDetail"
                                    (ngModelChange)="rebuildChart()"
                                    [itemsSource]="yesNoOptions"
                                    [displayMemberPath]="'display'"
                                    [selectedValuePath]="'value'"
                                    style="width: 115px"
                                ></wj-combo-box>
                            </div>
                        </form>
                    </div>
                </div>

                @if (currentRow) {
                    <div class="row mt-3">
                        <div class="col-12">
                            <h5 class="mb-2">{{ currentClassDisplay }} — {{ currentRow.monthLabel }}</h5>
                        </div>
                        <div class="col-md-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="text-muted">Wage</div>
                                    <strong>{{ currentRow.wageRate | currency }}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="text-muted">Burden</div>
                                    <strong>{{ currentRow.totalBurdenRate | currency }}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="text-muted">Fully Loaded</div>
                                    <strong>{{ currentRow.fullyLoadedRate | currency }}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="text-muted">Hours</div>
                                    <strong>{{ currentRow.hours | number: '1.0-1' }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <p class="text-muted mt-3 mb-1">
                    Rates use the month of the payroll end date and the class on the timecard. Overtime earning codes 4 and 5 are excluded from hours, wages, and the burden on those lines.
                    Burden is the liability amount posted on the remaining wage lines, divided by those hours. Estimated rates are not shown yet.
                </p>
                @if (unallocatedBurden > 0.005 || unallocatedBurden < -0.005) {
                    <p class="text-muted">
                        {{ unallocatedBurden | currency }} of burden in this range did not land on a wage line with hours and a class, so it is left out of the hourly rates.
                    </p>
                }
                @if (compareClasses && checkedClassCount > 5) {
                    <p class="text-muted">The chart shows the first five selected classes. Fully loaded rate only.</p>
                }

                <wj-flex-chart
                    style="height: 360px"
                    [itemsSource]="chartPoints"
                    [bindingX]="'month'"
                    [chartType]="'Line'"
                    [header]="compareClasses ? 'Fully Loaded by Class' : 'Labor Rate'"
                    [legendToggle]="true"
                >
                    <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
                    <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'$ / hour'" [format]="'c2'" [min]="0"></wj-flex-chart-axis>
                    <wj-flex-chart-axis wjProperty="axisX" format="MMM yy"></wj-flex-chart-axis>
                    @for (series of chartSeries; track series.binding) {
                        <wj-flex-chart-series [binding]="series.binding" [name]="series.name"></wj-flex-chart-series>
                    }
                </wj-flex-chart>

                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    appAutoSize
                    [padding]="73"
                    [isReadOnly]="true"
                    (initialized)="grid.initialize(mainGrid)"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Month'" [binding]="'month'" [width]="120" [format]="'MMM yyyy'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Class'" [binding]="'classDisplay'" [width]="280"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Hours'" [binding]="'hours'" [width]="100" [format]="'n1'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Wage'" [binding]="'wageRate'" [width]="110" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Payroll Taxes'" [binding]="'payrollTaxRate'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Workers Comp'" [binding]="'workersCompRate'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Health'" [binding]="'healthRate'" [width]="110" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'PTO'" [binding]="'ptoRate'" [width]="100" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Life / DisA / EAP'" [binding]="'lifeRate'" [width]="150" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'401k Match'" [binding]="'match401kRate'" [width]="120" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Fringe Combined'" [binding]="'fringeCombinedRate'" [width]="160" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Total Burden'" [binding]="'totalBurdenRate'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Fully Loaded'" [binding]="'fullyLoadedRate'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                @if (liabilityGroups.length > 0) {
                    <div class="text-muted small mt-2">
                        <div>Liability codes in each burden column</div>
                        @for (group of liabilityGroups; track group.name) {
                            <div>
                                <strong>{{ group.name }}</strong>
                                —
                                @for (code of group.codes; track code.code; let last = $last) {
                                    {{ code.code }} {{ code.description }}{{ last ? '' : ', ' }}
                                }
                            </div>
                        }
                    </div>
                }
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Equipment</a>
            <ng-template ngbNavContent>
                <equipment-rates></equipment-rates>
            </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>
                FOO - Field Operating Overhead
                @if (unmappedAccountCount > 0) {
                    <span class="badge text-bg-warning ms-1">{{ unmappedAccountCount }}</span>
                }
            </a>
            <ng-template ngbNavContent>
                <ul ngbNav #fooNav="ngbNav" class="nav-tabs mt-3" (activeIdChange)="tabChanged()">
                    <li [ngbNavItem]="1" [destroyOnHide]="false">
                        <a ngbNavLink>Charged FOO</a>
                        <ng-template ngbNavContent>
                            <overhead-rates (unmappedCountChange)="unmappedAccountCount = $event"></overhead-rates>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2" [destroyOnHide]="false">
                        <a ngbNavLink>Max FOO</a>
                        <ng-template ngbNavContent>
                            <max-overhead-rates></max-overhead-rates>
                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="fooNav" class="mt-2"></div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="false">
            <a ngbNavLink>Job Charge Rates</a>
            <ng-template ngbNavContent>
                <job-charge-rates></job-charge-rates>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
